import { z } from 'zod'

export const PomodoroPhaseSchema = z.enum(['work', 'break'])
export type PomodoroPhase = z.infer<typeof PomodoroPhaseSchema>

export const PomodoroStateSchema = z.enum(['running', 'paused', 'stopped'])
export type PomodoroSessionState = z.infer<typeof PomodoroStateSchema>

// Длительности фаз сотрудника (дефолт 25/5). Единственное, что правит экран
// настроек; фокус-кольцо читает их же.
export const PomodoroSettingsSchema = z.object({
  employeeId: z.string(),
  workMinutes: z.number().int().positive(),
  breakMinutes: z.number().int().positive(),
})
export type PomodoroSettings = z.infer<typeof PomodoroSettingsSchema>

// Активная сессия «одна на сотрудника»; remainingSeconds приходит только у paused
// (остаток замороженной фазы). На экране настроек не нужна — полную форму держим
// под фокус-срез.
export const PomodoroSessionSchema = z.object({
  id: z.string(),
  employeeId: z.string(),
  // Помодоро можно запускать без задачи (фокус taskless) — nullable.
  taskId: z.string().nullable(),
  workMinutes: z.number().int().positive(),
  breakMinutes: z.number().int().positive(),
  phase: PomodoroPhaseSchema,
  phaseStartedAt: z.string(),
  phaseEndsAt: z.string(),
  state: PomodoroStateSchema,
  remainingSeconds: z.number().int().nonnegative().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
})
export type PomodoroSession = z.infer<typeof PomodoroSessionSchema>

// GET /api/pomodoro — сессия (null, если не в фокусе) + всегда настройки.
export const PomodoroStateViewSchema = z.object({
  session: PomodoroSessionSchema.nullable(),
  settings: PomodoroSettingsSchema,
})
export type PomodoroStateView = z.infer<typeof PomodoroStateViewSchema>
